<template>
    <div>
        <b-modal id="add-edit-slots" hide-footer @hidden="closeModal">
            <template v-slot:modal-header="{ close }">
                <h4>{{isNew ? 'New' : 'Edit'}} slots</h4>
            </template>
            <template v-slot:default="{ hide }">
                <form @submit.prevent>
                    <loader :loading="false">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12">
                                <fg-input type="text" label="Slots" placeholder="Slots" 
                                    :class="{'has-error':$v.slots.$error}"
                                    v-model="$v.slots.$model"></fg-input>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-4 text-left">
								<p-button  type="link" round  @click.native.prevent="closeModal()">Back</p-button>
							</div>
                            <div class="col-8 text-right">
                                <p-button v-if="!isNew && !isModified" :loading="loading_set_default" @click.native.prevent="setDefault()" round class="btn btn-danger btn-sm">Set default</p-button>
                                <p-button v-if="isModified" :loading="loading_save" @click.native.prevent="saveSlots()" round class="btn btn-success btn-sm">Save</p-button>
                            </div>
                        </div>
                    </loader>
                </form>
            </template>
        </b-modal>
    </div>
</template>

<script>

import {required,numeric} from 'vuelidate/lib/validators';

export default {
    props:{
        day:Object
    },
    data(){
        return{
            slotsProxy:null,
            loading:false,
            loading_save:false,
            loading_set_default:false
        }
    },
    validations:{
        slots:{required,numeric}
    },
    computed:{
        slots:{
            get(){
                return this.slotsProxy===null ? this.day.slots : this.slotsProxy
            },
            set(newVal){
                this.slotsProxy = newVal
            }
        },
        isNew(){
            return this.day.slots===null;
        },
        isModified(){
            return this.$v.slots.$anyDirty;
        },
        idDay(){
            return this.day.id_day;
        }
    },
    methods:{
        closeModal(){
            this.$v.slots.$reset();
            this.slots = null;
            this.$bvModal.hide('add-edit-slots');
        },
        async saveSlots(){
            //console.log(this.temp_day);
            this.$v.slots.$touch();
            this.loading_save = true;
            if(!this.$v.slots.$invalid){
                if(this.day.id_day===null){
                    this.day.slots = this.slots;
                    let result = await this.$api.post('day',this.day);
                    this.day.id_day = result.data.id_day;
                    
                    this.$toast.success({
                        message:'Slots added',
                        icon: "ti-check"
                    });
                }
                else{
                    this.day.slots = this.slots;
                    let result = await this.$api.put('day/'+this.idDay,this.day);

                    this.$toast.success({
                        message:'Slots edited',
                        icon: "ti-check"
                    });
                }

                
            }
            this.loading_save = false;
        },
        async setDefault(){
            this.loading_set_default = true;
            this.day.slots = null;
            let result = await this.$api.put('day/'+this.idDay,this.day);
            //this.day.id_day = null;
            this.loading_set_default = false;
            this.closeModal();
        }
    }
}
</script>